if (!window.CollectionPopupController) {
    class CollectionPopupController {
        static SELECTORS = {
            card: '[data-collection-popup-card]',
            drawer: '[data-collection-popup-product-id]'
        };
        static ATTRS = {
            cardProductId: 'data-product-id',
            drawerProductId: 'data-collection-popup-product-id'
        };
        static CART_ADD = '/cart/add.js';

        constructor () {
            this._abort = new AbortController();
        }

        init () {
            if (!this._hasCards()) return;

            document.addEventListener(
                'submit',
                (event) => this._onSubmit(event),
                { capture: true, signal: this._abort.signal }
            );
        }

        destroy () {
            this._abort?.abort();
        }

        _hasCards () {
            return document.querySelector(CollectionPopupController.SELECTORS.card) != null;
        }

        _onSubmit (event) {
            const form = event.target instanceof HTMLElement ? event.target.closest('form') : null;
            if (!form) return;

            const action = (form.getAttribute('action') || '').toLowerCase();
            if (!action.includes('/cart/add')) return;

            const card = form.closest(CollectionPopupController.SELECTORS.card);
            if (!card) return;

            const productId = card.getAttribute(CollectionPopupController.ATTRS.cardProductId);
            if (!productId) return;

            const drawer = this._drawerFor(productId);
            if (!drawer) return;

            event.preventDefault();
            event.stopImmediatePropagation();

            this._submitAndOpen(form, drawer);
        }

        _drawerFor (productId) {
            const selector = `[${CollectionPopupController.ATTRS.drawerProductId}="${productId}"]`;
            return document.querySelector(selector);
        }

        async _submitAndOpen (form, drawer) {
            const formData = new FormData(form);
            try {
                const response = await fetch(CollectionPopupController.CART_ADD, {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: { Accept: 'application/json' },
                    body: formData
                });

                if (!response.ok) {
                    console.error('[collection-popup] add to cart failed', response.status);
                    return;
                }

                this._notifyCartChange();
                this._openDrawer(drawer);
            } catch (error) {
                console.error('[collection-popup] add to cart error', error);
            }
        }

        _notifyCartChange () {
            const detail = { silent: true, preventDrawerOpen: true };
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail }));
        }

        _openDrawer (drawer) {
            if (typeof drawer.show === 'function') {
                drawer.show();
                return;
            }
            if ('open' in drawer) {
                drawer.open = true;
                return;
            }
            drawer.setAttribute('open', '');
        }
    }

    window.CollectionPopupController = CollectionPopupController;

    const init = () => {
        if (window.__collectionPopupInit) return;
        window.__collectionPopupInit = true;
        new CollectionPopupController().init();
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
}
